module.exports = __webpack_public_path__ + "static/media/app-store-badge.8c4986ee.svg";